<template>
  <div class="content-container">
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :rows="rows"
        row-selection="single"
        class="agGrid"
        @selectionChanged="onSelectRow"
      />
    </div>
    <div class="grid-bottom" />
    <div class="button-containers mb-0">
      <button
        :disabled="!selectedRow"
        class="btn primary small outline"
        @click="deleteConfig"
      >
        {{ $t('button.deleteConfiguration') }}
      </button>

      <button
        :disabled="!selectedRow"
        class="btn primary small"
        @click="fnShowEditDialog"
      >
        {{ $t('button.modifyConfiguration') }}
      </button>
      <button class="btn primary small" @click="fnShowAddDialog">
        {{ $t('button.addConfiguration') }}
      </button>
    </div>
    <!-- <el-col class="bottom-btns-container">
      <el-button type="primary" @click="fnShowAddDialog">
        Thêm cấu hình
      </el-button>
      <el-button type="danger" @click="deleteConfig"> Xóa cấu hình </el-button>
    </el-col> -->
    <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleConfigurationModify')
          : $t('dialog.titleConfigurationAdd')
      "
      class="body-overflow__visible"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">{{ $t('field.code') }}</div>
                  <validation-provider
                    rules="required|no_special|max:20"
                    :name="$t('field.code')"
                  >
                    <div class="child-w-80">
                      <input
                        v-model="formConfig.code"
                        type="text"
                        :readonly="isEdit"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    {{ $t('field.transactionCode') }}
                  </div>
                  <validation-provider
                    rules="required"
                    :name="$t('field.transactionCode')"
                  >
                    <div class="child-w-80">
                      <select-with-search-table
                        style="width: 100%"
                        index-field="id"
                        :search-fields="[
                          'code',
                          'transaction_code',
                          'description'
                        ]"
                        :selected-index-field-value="
                          formConfig?.sub_transaction_id
                        "
                        :rows="subTransactionOptions"
                        :columns="subTransactionOptionsCols"
                        :value="formConfig?.sub_transaction_id"
                        :dropdown-width="400"
                        @selectionChanged="onSelectFormSubTrans"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          <div>
                            <span v-if="selectedData?.code">
                              {{ selectedData.transaction_code }} -
                              {{ selectedData.code }} -
                              {{ selectedData.description }}</span
                            >
                          </div>
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateConfig">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="addConfig">
            {{ $t('button.create') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
const getDefaultFormConfig = () => ({
  code: null,
  transaction_id: null,
  transaction_nm: null,
  sub_transaction_id: null,
  sub_transaction_nm: null
})

import {
  getCancelOrNoShowListApi,
  addCancelOrNoShowApi,
  updateCancelOrNoShowApi,
  deleteCancelOrNoShowApi
} from '@/api/Service_Policy/cancelOrNoShow'
import { getSubTransactionListApi } from '@/api/Transaction/subTransaction'
import { Message } from 'element-ui'

export default {
  data() {
    return {
      loading: false,
      formConfig: {
        code: null,
        transaction_id: null,
        transaction_nm: null,
        sub_transaction_id: null,
        sub_transaction_nm: null
      },
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      item: {
        code: '',
        transaction_code: '',
        id: null
      },
      columns: [
        {
          headerName: this.$t('grid.column.code'),
          field: 'code',
          minWidth: 100,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'name',
          minWidth: 600,
          flex: 3,
          // cellRenderer: 'CellRenderTextInput',
          valueGetter: params =>
            `${params.data.transaction_nm} - ${params.data.sub_transaction_nm}${
              params.data.sub_transaction_desc
                ? ' - ' + params.data.sub_transaction_desc
                : ''
            }`
          // cellClass: 'grid-cell-centered'
        }
      ],
      rows: [],
      selectedRow: null,

      subTransactionOptions: [],
      subTransactionOptionsCols: [
        {
          headerName: this.$t('grid.column.transactionCode'),
          field: 'transaction_code',
          tooltipField: 'transaction_code',

          minWidth: 100,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.subTransactionCode'),
          field: 'code',
          tooltipField: 'code',
          minWidth: 150,
          flex: 1
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'description',
          tooltipField: 'description',
          minWidth: 100,
          flex: 1
        }
      ]
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetFormConfig()
    }
  },

  mounted() {
    this.attachData()
    this.fnGetSubTransOptions()
  },
  methods: {
    async attachData() {
      this.loading = true
      let data = await getCancelOrNoShowListApi()
      this.loading = false
      this.rows = data.data
    },
    async addConfig() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      addCancelOrNoShowApi(this.formConfig)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
          this.dialogFormVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },
    async updateConfig() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      updateCancelOrNoShowApi(this.formConfig)
        .then(res => {
          this.$message({
            type: 'success',
            message: this.$t('successMsg.' + res.message)
          })
          this.attachData()
          this.dialogFormVisible = false
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.' + err.response.data.message)
          })
        })
    },

    async deleteConfig() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)

      this.$vxConfirm(this.$t('alert.deleteConfiguration'), {
        resolveText: 'OK',
        rejectText: 'Cancel',
        resolve: () => {
          deleteCancelOrNoShowApi({
            ids: id_list
          })
            .then(res => {
              this.$message({
                type: 'success',
                message: this.$t('successMsg.' + res.message)
              })
              this.attachData()
            })
            .catch(err => {
              this.$message({
                type: 'error',
                message: this.$t('errorMsg.' + err.response.data.message)
              })
            })
        }
      })
    },

    onSelectRow(rows) {
      this.selectedRow = rows?.[0]
    },
    resetFormConfig() {
      setTimeout(() => {
        this.isEdit = false
        this.formConfig = getDefaultFormConfig()
      }, 500)
    },
    fnShowAddDialog() {
      this.dialogFormVisible = true
    },
    fnShowEditDialog() {
      this.isEdit = true
      this.formConfig = { ...this.selectedRow }
      this.dialogFormVisible = true
    },

    // Fetch select options
    async fnGetSubTransOptions() {
      const resData = await getSubTransactionListApi()
      this.subTransactionOptions = resData.data
    },

    onSelectFormSubTrans(data) {
      const { id, transaction_id } = data
      this.formConfig = {
        ...this.formConfig,
        ...{
          transaction_id: transaction_id,
          sub_transaction_id: id
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-dialog__body {
  overflow: visible !important;
}
</style>
